import { Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { ButtonCompo } from "../../../components/Comman/Button";
import MaterialUITableWithTextField from "../../../components/Comman/RT/MaterialUITableWithTextField";
import DynamicFormWithoutValidation from "../../../components/dynamicscreens/DynamicFormWithoutValidation";
import { withRouter } from "../../../components/withRouter";
import endpoint from "../../../config/endpoints";
import { addOneRecordMsg, noInternetMsg, saveFailedMsg, saveWarningMsg, savemsg, serverMsg, updateData, updateMsg } from "../../../config/messageconstant";
import { leaveStructureJson } from "../../../DynamicFormsJson/MastersJSON/leaveStructure";
import { setLeaveType } from "../../../Slice/LeaveType.slice";
import { apiGet, apiPost } from "../../../utils/api_service";
import {
  showLoador,
  showNotification,
} from "../../Landing/Landing.slice";
import LeaveStructureDetailsTable from "./LeaveStructureDetailsTable";

class LeaveStructureForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formErrors: {},
      formErrorForDetails: {},
      fieldData: { type: "1" },
      DataToSet: [],
      leaveList: []
    };
  }

  async componentDidMount() {
    const { showLoador, showNotification } = this.props;
    const { fieldData } = this.state

    if (navigator.onLine) {

      showLoador({ loador: true });
      await apiGet({
        url: endpoint.leaveType + "/get-active-list",
      }).then(async ({ data, success }) => {
        if (success && data.data != null) {

          let leaveTypeData = data.data;

          if (this.props.params.id) {
            await apiGet({
              url: leaveStructureJson.apiBaseURL + "/" + this.props.params.id,
            }).then(({ data, success }) => {
              if (success) {
                if (!data.error) {
                  const leaveList = leaveTypeData.map((row, index) => {
                    const leaveDataObj =
                      data.data.leaveStructureDetails.find((detailsData) => detailsData.leaveType.id == row.id) || {};
                    return {
                      ...row,
                      index: index + 1,
                      detailsId: leaveDataObj?.id || "",
                      leaveType: row,
                      allotedLeaves: leaveDataObj?.allotedLeaves || 0,
                      minimumDaysPerLeave: leaveDataObj?.minimumDaysPerLeave || 0,
                      maximumDaysPerLeave: leaveDataObj?.maximumDaysPerLeave || 0,
                      maximumCarryForwardDays: leaveDataObj?.maximumCarryForwardDays || 0,
                      canBeEncashed: leaveDataObj?.canBeEncashed || 0,
                    }
                  });

                  this.setState({
                    fieldData: {
                      ...fieldData,
                      name: data.data.name
                    },
                    leaveList,
                  })
                }
              } else {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            });
          } else {
            const row = leaveTypeData.map((rowObj, index) => {
              return {
                ...rowObj,
                leaveType: rowObj,
                index: index + 1,
                allotedLeaves: 0,
                minimumDaysPerLeave: 0,
                maximumDaysPerLeave: 0,
                maximumCarryForwardDays: 0,
                canBeEncashed: 0,
              };
            });
            this.setState({ leaveList: row })
          }

        } else {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
      showLoador({ loador: false });

    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  onDataChange = (fieldName, newValue) => {

    const { fieldData } = this.state;
    const dataToSearch = {};
    const dataToReset = { ...this.state.fieldData };
    let listError = false;
    leaveStructureJson.fieldMeta.map((currentField) => {
      if (currentField.getDate && currentField.dataKey === fieldName) {
        dataToReset[currentField.getDate] = newValue.add(365, "day");
      }
      if (currentField.dataKey === fieldName && currentField.getListId) {
        const masterKeyList = currentField.getListId.split(",");
        masterKeyList.map((key) => {
          if (fieldName === key) {
            dataToSearch[key] = newValue;
          } else if (fieldData[key]) {
            dataToSearch[key] = fieldData[key];
          }
          return null;
        });
      }
      if (currentField.getListFrom) {
        const masterKeyList = currentField.getListFrom.split(",");
        masterKeyList.map((key) => {
          if (key == fieldName && dataToReset[key]) {
            delete dataToReset[currentField.dataKey];
          }
        });
      }
      if (
        !listError &&
        fieldData[currentField.dataKey] &&
        currentField.controlType != "datepicker" &&
        currentField.getListFrom == undefined
      ) {
        dataToReset[currentField.dataKey] = fieldData[currentField.dataKey];
      }
      return null;
    });

    dataToReset[fieldName] = newValue;
    this.setState({
      fieldData: dataToReset,
    });
  };


  mandatoryCheck = () => {
    let formValid = true;
    const { fieldData } = this.state;

    let formErrors = {};
    leaveStructureJson.fieldMeta.forEach((currentField) => {
      if (currentField.isMandatory) {
        if (
          (currentField.controlType === "datepicker" &&
            (fieldData[currentField.dataKey] === undefined ||
              fieldData[currentField.dataKey] === "")) ||
          (currentField.controlType !== "datepicker" &&
            currentField.controlType !== "autocomplete" &&
            (fieldData[currentField.dataKey] === undefined ||
              fieldData[currentField.dataKey] === null ||
              fieldData[currentField.dataKey].toString().trim() === ""))
        ) {
          formValid = false;

          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `*${currentField.label} is required`,
            },
          };
        } else if (
          currentField.controlType === "autocomplete" &&
          (fieldData[currentField.dataKey] === undefined ||
            fieldData[currentField.dataKey] === null ||
            (!currentField.isRootLevelKey &&
              fieldData[currentField.dataKey] != undefined &&
              fieldData[currentField.dataKey] != null &&
              fieldData[currentField.dataKey].id == null))
        ) {
          formValid = false;

          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `*${currentField.label} is required`,
            },
          };
        }
      } else if (currentField.controlType === "hideTextfield") {
        if (
          fieldData[currentField.tableDataKey] === currentField.open &&
          (fieldData[currentField.dataKey] === undefined ||
            fieldData[currentField.dataKey] === "")
        ) {
          formValid = false;

          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `*${currentField.error} is required`,
            },
          };
        }
      } else if (currentField.controlType === "hideDatepicker") {
        if (
          fieldData[currentField.tableDataKey] === currentField.open &&
          (fieldData[currentField.dataKey] === undefined ||
            fieldData[currentField.dataKey] === null ||
            fieldData[currentField.dataKey].toString().trim() === "")
        ) {
          formValid = false;

          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `*${currentField.label} is required`,
            },
          };
        }
      } else if (currentField.controlType === "hideAutocomplete") {
        if (
          fieldData[currentField.tableDataKey] === currentField.open &&
          (fieldData[currentField.dataKey] === undefined ||
            fieldData[currentField.dataKey] === null ||
            fieldData[currentField.dataKey].toString().trim() === "")
        ) {
          formValid = false;

          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `*${currentField.label} is required`,
            },
          };
        }
      } else if (currentField.controlType === "hideMultiSelect") {
        if (
          fieldData[currentField.tableDataKey] === currentField.open &&
          (fieldData[currentField.dataKey] === undefined ||
            fieldData[currentField.dataKey] === null ||
            (fieldData[currentField.dataKey] &&
              fieldData[currentField.dataKey].length == 0))
        ) {
          formValid = false;

          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `*${currentField.label} is required`,
            },
          };
        }
      }
    });
    this.setState({
      formErrors: formErrors,
    });
    return formValid;
  };
  ValidationCheck = () => {
    let formValid = true;
    const { fieldData } = this.state;

    let formErrors = {};
    leaveStructureJson.fieldMeta.forEach((currentField) => {
      if (currentField.valid) {
        if (
          currentField.validName === "email" &&
          !validEmail.test(fieldData[currentField.dataKey])
        ) {
          formValid = false;
          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `${currentField.label} is Invalid`,
            },
          };
        }
        if (
          currentField.validName === "zero" &&
          fieldData[currentField.dataKey] === 0
        ) {
          formValid = false;
          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `${currentField.label} is Invalid`,
            },
          };
        }
      }
    });
    this.setState({
      formErrors: formErrors,
    });
    return formValid;
  };
  checkValidationOnSubmitForDetails = () => {
    const { leaveList } = this.state;
    let formErrorForDetails = {};
    let formIsValid = true;
    let errorMessage = "This field is required";

    leaveList.map((item) => {
      if (item.allotedLeaves === "" || item.allotedLeaves === null) {
        formIsValid = false;
        formErrorForDetails[`allotedLeavesError${item.id}`] = errorMessage;
      } else if (item.minimumDaysPerLeave === "" || item.minimumDaysPerLeave === null) {
        formIsValid = false;
        formErrorForDetails[`minimumDaysPerLeaveError${item.id}`] = errorMessage;
      } else if (item.maximumDaysPerLeave === "" || item.maximumDaysPerLeave === null) {
        formIsValid = false;
        formErrorForDetails[`maximumDaysPerLeaveError${item.id}`] = errorMessage;
      } else if (item.maximumCarryForwardDays === "" || item.maximumCarryForwardDays === null) {
        formIsValid = false;
        formErrorForDetails[`maximumCarryForwardDaysError${item.id}`] = errorMessage;
      }
    });

    this.setState({ formErrorForDetails });
    return formIsValid;
  };


  checkValidationOnSubmit = () => {
    if (this.mandatoryCheck()) {
      return this.ValidationCheck();
    } else {
      return false;
    }
  };
  onSubmit = async () => {
    const { fieldData, leaveList } = this.state;
    const checkValidationData = await this.checkValidationOnSubmit();
    if (checkValidationData && this.checkValidationOnSubmitForDetails()) {
      if (navigator.onLine) {

        let leaveTypeList = []
        if (this.props.params.id) {
          leaveList.map((row) => {
            if (row.allotedLeaves != 0 && row.allotedLeaves != "") {
              leaveTypeList.push({
                ...row,
                id: row?.detailsId || undefined,
                leaveType: {
                  id: row.leaveType != null && row.leaveType.id ? row.leaveType.id : ""
                },
                allotedLeaves: row.allotedLeaves,
                minimumDaysPerLeave: row.minimumDaysPerLeave,
                maximumDaysPerLeave: row.maximumDaysPerLeave,
                maximumCarryForwardDays: row.maximumCarryForwardDays,
                canBeEncashed: row.canBeEncashed,
                isActive: 1,
                extra1: null,
              })
            }
          })
        } else {
          leaveList.map((row) => {
            if (row.allotedLeaves != 0 && row.allotedLeaves != "") {
              leaveTypeList.push({
                leaveType: {
                  id: row.leaveType != null && row.leaveType.id ? row.leaveType.id : ""
                },
                allotedLeaves: row.allotedLeaves,
                minimumDaysPerLeave: row.minimumDaysPerLeave,
                maximumDaysPerLeave: row.maximumDaysPerLeave,
                maximumCarryForwardDays: row.maximumCarryForwardDays,
                canBeEncashed: row.canBeEncashed,
                isActive: 1,
                extra1: null,
              })
            }
          })
        }

        let dataToSave = {
          name: fieldData.name,
          isActive: 1,
          extra1: null,
          leaveStructureDetails: leaveTypeList
        };

        if (this.props.params.id) {
          dataToSave = {
            id: this.props.params.id,
            name: fieldData.name,
            isActive: 1,
            extra1: null,
            leaveStructureDetails: leaveTypeList
          };
        }
        if (leaveTypeList.length != 0) {
          swal({
            title: "Are you sure?",
            text: this.props.params.id ? updateData : saveWarningMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
          }).then((willDelete) => {
            if (willDelete) {
              this.onSave(dataToSave);
            }
          });
        } else {
          // Atleast one record Add
          this.props.showNotification({
            msg: addOneRecordMsg,
            severity: "error",
          });
        }

      } else {
        this.props.showNotification({
          msg: noInternetMsg,
          severity: "error",
        });
      }
    }

  };

  onSave = async (dataToSave) => {
    const { showLoador, setProductList, showNotification, category } =
      this.props;

    if (navigator.onLine) {
      showLoador({ loador: true });
      await apiPost({
        url: endpoint.leaveStructure,
        postBody: dataToSave,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          showNotification({ msg: this.props.params.id ? updateMsg : savemsg });
          window.location.replace("/leave-structure")
        } else {
          showNotification({ msg: saveFailedMsg, severity: "error" });
        }
        return success;
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onChangeRadioGroup = (e, id) => {
    const { leaveList } = this.state;
    const updatedList = leaveList.map((dataObj) => {
      if (dataObj.id == id) {
        return {
          ...dataObj,
          canBeEncashed: Number(e.target.value),
        };
      }
      return dataObj;
    });

    this.setState({
      leaveList: updatedList,
    });
  };

  onChangeRadioGroup = (e, id) => {
    const { leaveList } = this.state;
    const updatedList = leaveList.map((dataObj) => {
      if (dataObj.id == id) {
        return {
          ...dataObj,
          canBeEncashed: Number(e.target.value),
        };
      }
      return dataObj;
    });

    this.setState({
      leaveList: updatedList,
    });
  };

  onChangeTextField = (e, id) => {
    const { name, value } = e.target;

    if (value < 0) value = 0;

    this.setState((prev) => {
      const updatedList = prev.leaveList.map((item) =>
        item.id == id ? { ...item, [name]: value } : item
      );

      const errorKey = `${name}Error${id}`;
      const updatedErrors = { ...(prev.formErrorForDetails || {}) };

      if (updatedErrors[errorKey]) {
        delete updatedErrors[errorKey];
      }

      return {
        leaveList: updatedList,
        formErrorForDetails: updatedErrors,
      };
    });
  };


  render() {
    const { leaveList, formErrors, fieldData } = this.state
    let isShowExtraFieldAtLeaveStructure =
      localStorage.getItem("isShowExtraFieldAtLeaveStructure") !== null ? localStorage.getItem("isShowExtraFieldAtLeaveStructure") : 0;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
          }}
          elevation={0}
        >
          <DynamicFormWithoutValidation
            getListById={this.getListById}
            showBackToList={true}
            showSaveBtnMain={false}
            screenTitle={leaveStructureJson.screenTitle}
            fieldMeta={leaveStructureJson.fieldMeta}
            apiBaseURL={leaveStructureJson.apiBaseURL}
            saveBtnText={"Submit"}
            onDataChange={this.onDataChange}
            fieldData={fieldData}
            formErrors={formErrors}
          />
          <br />
          <LeaveStructureDetailsTable
            dataList={leaveList}
            onChangeTextField={this.onChangeTextField}
            onChangeRadioGroup={this.onChangeRadioGroup}
            clickSubmitHandler={this.onSubmit}
            formErrorForDetails={this.state.formErrorForDetails}
            isShowExtraFieldAtLeaveStructure={isShowExtraFieldAtLeaveStructure}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  leaveTypeList: state.leaveType,
});
const mapDispatchToProps = {
  setLeaveType,
  showLoador,
  showNotification,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(LeaveStructureForm);
